const MenuFooter = ({ children }) => {
  return (
    <>
      <div className='w-full h-auto fixed bottom-0 z-30 md:max-w-7xl md:mx-auto'>
        <div
          className='w-full h-full  backdrop-blur-sm bg-white/50 absolute  
        rounded-tr-2xl rounded-tl-2xl overflow-hidden'
        ></div>

        <div className='w-full py-2 relative h-full  flex justify-center gap-3 items-center'>
          {children}
        </div>
      </div>
    </>
  )
}

export default MenuFooter
